export const ReportValidation = (formData) => {
    const errors = {};

    if (!formData.ReportTitle.trim()) {
        errors.ReportTitle = ' This field is required';
    }
    if (!formData.Link.trim()) {
        errors.Link = ' This field is required';
    }
    if (!formData.ReportName.trim()) {
        errors.ReportName = ' This field is required';
    }
    if (formData.ModuleID === "0" || formData.ModuleID === 0) {
        errors.ModuleID = ' This field is required';
    }


    return errors;
};

